var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2457 2.71416C22.4255 2.71416 28.255 4.18852 36.7342 7.13724C45.0462 10.0189 49.7042 11.4598 50.7083 11.4598C50.7641 11.4598 50.792 11.4598 50.792 11.4598C55.0874 11.4598 58.1835 7.63986 60.0802 0L73.8032 4.22203C72.1854 11.8619 69.6472 18.597 66.1886 24.4274C62.7299 30.1908 59.1318 33.0725 55.3942 33.0725C51.6567 33.0725 45.604 31.5312 37.2363 28.4484C28.9244 25.3657 23.2622 23.8243 20.2499 23.8243C17.2933 23.8243 14.6993 26.9406 12.4679 33.1731L0 25.3322C4.40699 10.2535 10.8222 2.71416 19.2457 2.71416Z",
    fill: "#C84C2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4426 44.5411C23.6223 44.5411 29.4518 46.0155 37.9311 48.9642C46.243 51.8459 50.901 53.2868 51.9052 53.2868C51.9609 53.2868 51.9888 53.2868 51.9888 53.2868C56.2843 53.2868 59.3803 49.4668 61.277 41.827L75 46.049C73.3823 53.6889 70.8441 60.424 67.3854 66.2544C63.9268 72.0178 60.3287 74.8995 56.5911 74.8995C52.8535 74.8995 46.8009 73.3581 38.4331 70.2754C30.1212 67.1926 24.4591 65.6513 21.4467 65.6513C18.4901 65.6513 15.8961 68.7675 13.6647 75L1.19684 67.1591C5.60383 52.0805 12.0191 44.5411 20.4426 44.5411Z",
    fill: "#C84C2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.abdb59d2f0a7c250a8b605cd49a7e96b.svg";
export { ForwardRef as ReactComponent };